// Home.js
import React, { useState } from "react"
import MovieSpaceWheel from "./MovieSpaceWheel"
import TimeMachineRail from "./TimeMachineRail"
import "./Home.css"

function Home() {
  // default to the current month/year — the wheel shows films from this window
  const now = new Date()
  const [period, setPeriod] = useState({ year: now.getFullYear(), month: now.getMonth() + 1 })

  return (
    <div className="home-container">
      <div className="content">
        <div className="emotions-movies-container">
          {/* mirrors the rail width on the right so the wheel sits dead-centre */}
          <div className="rail-spacer" aria-hidden />
          <div className="emotion-wheel">
            <MovieSpaceWheel period={period} />
          </div>
          <TimeMachineRail period={period} onSelect={setPeriod} />
        </div>
      </div>
    </div>
  )
}

export default Home
